<div class="lum-c-shipments-ag-table">
  <div
    *ngIf="showGridActions"
    class="lum-c-shipments-ag-table__actions d-flex justify-content-end mb-3"
  >
    <lum-shipments-grid-actions
      [salesOrderId]="salesOrderId"
      (refreshGridEvent)="onRefreshTable()"
    >
    </lum-shipments-grid-actions>
  </div>

  <ag-grid-angular
    class="ag-theme-alpine ag-theme-lum"
    [columnDefs]="columnDefs"
    [gridOptions]="gridOptions"
    (gridReady)="onGridReady($event)"
    [style.height]="height"
    [style.width]="width"
  ></ag-grid-angular>
</div>
